// Side-effect module: registers the host's common-hook implementations with
// @p81-common/shell-core-js so MFEs (and any other consumer of the shared
// npm package) can import the same hooks via:
//
//   import { useDocumentTitle } from "@p81-common/shell-core-js";
//
// instead of going through the federation runtime ('shell/commonHooks'). Must
// be imported eagerly from the host's bootstrap (index.js or App.tsx) before
// any MFE route is mounted — otherwise an MFE that calls a wrapper hook
// before registration will throw with a clear pointer back here.

import { setCommonHooks } from "@p81-common/shell-core-js";
import * as commonHooks from "./index";

// Hooks that aren't re-exported from ./index aggregator but ARE consumed by
// MFEs via sub-path imports today (and so need to be in the registry too).
import useExposedState from "./useExposedState";
import useTabRefsWithDirtyCheck from "./useTabRefsWithDirtyCheck";
import { useEditableList } from "./useEditableList";
import { useDebouncedValue } from "./useDebouncedValue";

export const hooksBag = {
  ...commonHooks,
  useExposedState,
  useTabRefsWithDirtyCheck,
  useEditableList,
  useDebouncedValue,
};

setCommonHooks(hooksBag);
